import { Button } from '@mui/material'
import { useState, useContext } from 'react'
import { validateKYC, validateKYCAndUpdate } from '../../services/Customer';
import useService from '../../hooks/useService';
import { AADHAR } from '../../utils/constant';
import { NotificationContext } from '../../contexts/NotificationContext';
import { ICustomerSummary } from '../../Models/Customer';

const toBase64 = (file: File): Promise<string> =>
    new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result ? reader.result.toString() : '')
        reader.onerror = (error) => reject(error)
    })

const CustomerAadharUpload = ({ customerDetail, modalClose, onSuccess }: { customerDetail: ICustomerSummary, modalClose: () => any, onSuccess: () => any }) => {
    const [aadharStatus, setAadharStatus] = useState(customerDetail.kycInfo?.addressProofDocType === "aadhaar" ? false : true)
    const [aadharDetails, setAadharDetails] = useState(customerDetail.kycInfo)
    const [kycStatus, setKycStatus] = useState(customerDetail.kycStatus === "valid" ? "Y" : "I")
    const { notify } = useContext(NotificationContext)

    const [validateAadharDetails, setValidateAadharDetails] = useState<any>({});
    const [aadharVerifyError, setAadharVerifyError] = useState("");
    const [isErrorInAadharVerification, setErrorInAadharVerification] = useState(false);

    const { execute } = useService()

    const [frontAadharImage, setFrontAadharImage] = useState<string>('')
    const [isfrontAadharImage, setIsFrontAadharImage] = useState<boolean>(false)
    const [backAadharImage, setBackAadharImage] = useState<string>('')
    const [isbackAadharImage, setIsBackAadharImage] = useState<boolean>(false)
    const [aadharVerified, setAadharVerified] = useState<boolean>(false)
    const [showFront, setShowFront] = useState<any>([{ uri: '' }])
    const [showBack, setShowBack] = useState<any>([{ uri: '' }])

    const handleDocumentChange = async (e: any, side: string) => {

        e.preventDefault();
        const file = e.target.files ? e.target.files[0] : null

        if (!file) return

        const base64File = await toBase64(file)

        if (side === AADHAR.FRONT_SIDE) {
            showFront[0].uri = base64File
            setShowFront(showFront)
            setFrontAadharImage(base64File.split(',')[1]);
            setIsFrontAadharImage(true)
        } else if (side === AADHAR.BACK_SIDE) {
            showBack[0].uri = base64File
            setShowBack(showBack)
            setBackAadharImage(base64File.split(',')[1]);
            setIsBackAadharImage(true)
        }
    }

    const handleVerify = async () => {
        if (frontAadharImage.length > 0 && backAadharImage.length > 0) {
            let payload: any = {
                "customerRefNo": customerDetail.customerRefNo,
                "docId": "1",
                "frontImage": frontAadharImage,
                "backImage": backAadharImage
            }
            const { data, error } = await execute(() => validateKYC(payload))

            console.log("res from validate KYC", data, error)
            if (data != null) {
                setAadharVerified(true)
                setValidateAadharDetails(data);
            } else {
                setErrorInAadharVerification(true);
                if (error)
                    setAadharVerifyError(error?.reason!);
                else
                    setAadharVerifyError("Provided Image is Invalid. Please Try Again.");
            }
        } else {
            setAadharVerifyError("Required Aadhar Front and Back side Image");
        }
    }
    const handleSubmit = async () => {
        if (aadharVerified) {
            if (frontAadharImage.length > 0 && backAadharImage.length > 0) {

                let payload: any = {
                    "customerRefNo": customerDetail.customerRefNo,
                    "docId": "1",
                    "frontImage": frontAadharImage,
                    "backImage": backAadharImage,
                    "partnerId": customerDetail.partnerId
                }
                const { data, error } = await execute(() => validateKYCAndUpdate(payload))

                console.log("res from validateKYCUpdate", data, error);
                if (data === null) {
                    setErrorInAadharVerification(true);
                    if (error)
                        setAadharVerifyError(error?.reason!);
                    else
                        setAadharVerifyError("Provided Image is Invalid. Please Try Again.");
                } else {
                    setValidateAadharDetails(data);
                    if (setAadharStatus)
                        setAadharStatus(false);
                        onSuccess()
                    modalClose()
                }
            }
        } else {
            notify(aadharVerifyError, 'error')
            // modalClose(false)
        }
    }
    return (
        <div className='panContainer'>
            {
                kycStatus === 'Y' && aadharDetails && aadharDetails.addressProofDocType && (
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }} >
                        <div className="panMessageBlock">
                            <div className="panMessage">
                                Aadhar is already Verified.
                                <span>
                                    <img src={"/assets/images/greentick.png"} alt={"tick"} className="greenTick" width={15} />
                                    {"********" + aadharDetails?.addressProofDocNo?.substring(10, 14)}
                                </span>
                            </div>
                        </div>
                        {/* <div className="container changeUploadedDetails"> */}
                        <div className={"changeButtonSection"}>
                            <Button className="uploadDocuments" type="button" onClick={e => {
                                setAadharStatus(true)
                                setAadharDetails(undefined)
                            }}>
                                Change Aadhar
                            </Button>
                            {/* <UploadFileIcon /> */}
                        </div>
                    </div >
                )
            }
            {
                aadharStatus && (
                    <>
                        {/* {isUploadAadhar && ( */}
                        <div className="panDetails">
                            <div className="documentUpload">
                                {aadharStatus && aadharDetails && (
                                    <span className="profileUpdatePan">
                                        Add Aadhar details
                                    </span>)}
                                {aadharStatus && !aadharDetails && (
                                    <div className="panMessageBlock">
                                        <div className="panMessage">
                                            Aadhar details are mandatory
                                        </div>
                                    </div>)}
                                <div className="documents">
                                    <div className="uploadContainer">
                                        <div>
                                            {isfrontAadharImage ?
                                                <img src={showFront[0].uri} alt={"aadhar card image"} width={220}
                                                    height={130} />
                                                :
                                                <img src={'/assets/images/aadhar-front.jpeg'}
                                                    alt="sample aadhar" width="220" height="130" />
                                            }
                                            <input
                                                accept="image/*"
                                                type="file"
                                                id="front-image"
                                                style={{ display: 'none' }}
                                                onChange={(e) => {
                                                    handleDocumentChange(e, AADHAR.FRONT_SIDE)
                                                }}
                                            />
                                            <label htmlFor="front-image">
                                                <div className="uploadDocument">
                                                    {isfrontAadharImage ? "CHANGE FRONT" : "UPLOAD FRONT"}
                                                    <img src={'/assets/images/Vector.png'}
                                                        alt="Picture of the author"
                                                        width="11.2px"
                                                        height="14px"
                                                        background-color="#cfa04f;" />
                                                </div>
                                            </label>
                                        </div>

                                        <div>
                                            {isbackAadharImage ?
                                                <img src={showBack[0].uri} alt={"aadhar card back image"} width={220}
                                                    height={130} />
                                                :
                                                <img src={'/assets/images/aadhar-back.jpeg'}
                                                    alt="sample aadhar" width="220" height="130" />
                                            }
                                            <input
                                                accept="image/*"
                                                type="file"
                                                id="back-image"
                                                style={{ display: 'none' }}
                                                onChange={(e) => {
                                                    handleDocumentChange(e, AADHAR.BACK_SIDE)
                                                }}
                                            />
                                            <label htmlFor="back-image">
                                                <div className="uploadDocument">
                                                    {isbackAadharImage ? "CHANGE BACK" : "UPLOAD BACK"}
                                                    <img src={'/assets/images/Vector.png'}
                                                        alt="Picture of the author"
                                                        width="11.2px"
                                                        height="14px"
                                                        background-color="#cfa04f;" />
                                                </div>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="descriptionForDoc">
                                        You can upload the JPEG or PNG format less than 2 Mb
                                    </div>
                                    {isErrorInAadharVerification ? (
                                        <div className="alertForDoc">
                                            {aadharVerifyError}
                                        </div>
                                    ) : (
                                        <></>
                                    )}
                                </div>
                            </div>

                            {/* <div className="instructionsToUpload">
                                <div className="samplePanSection">
                                    {/* <span>HOW TO UPLOAD?</span> */}
                            {/* <div className="samplePanImage">
                                        {/* <img src={'/assets/images/aadhar-front.jpeg'}
                                                                alt="sample aadhar" width="200" height="100" />
                                            <img src={'/assets/images/aadhar-back.jpeg'}
                                                                alt="sample aadhar" width="200" height="100" />
                                    </div> */}
                            {/*  </div>
                                <div className="list">
                                    <ul>
                                        <li>You can upload the JPEG or PNG format</li>
                                        <li>Document size should be less than 2 Mb</li>
                                        <li>Image should be clearly visible</li>
                                        <li>Cropped or cut images will not be accepted</li>
                                    </ul>
                                </div>
                            </div> */}
                        </div>
                        {/* // )} */}

                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <Button variant='contained' onClick={() => aadharVerified ? handleSubmit() : handleVerify()}>
                                {aadharVerified ? "Submit" : "Verify"}
                            </Button>
                        </div>

                    </>
                )
            }
        </div >
    )
}

export default CustomerAadharUpload

const MailTo = (params: any) => {
    const { email, subject, body } = params;

    return (
        <a className={"contactUsLink"}
            href={`mailto:${email}?subject=${subject || ""}&body=${body || ""}`}>
            Contact us
        </a>
    );
}